<script setup>
import {useRouting} from "@/composables/routing.js";
const {href,url} = useRouting();

import { Head } from '@inertiajs/vue3'
import { Link } from '@inertiajs/vue3';
</script>

<template>
    <Head>
        <title>Widerrufsrecht</title>
        <meta name="description" content="In der Widerrufsbelehrung finden Sie alle Informationen zu Ihrem Widerrufsrecht.">
        <link rel="canonical" :href="url('/legal/widerrufsbelehrung', 'de')">
        <link rel="alternate" hreflang="en" :href="url('/legal/widerrufsbelehrung', 'en')">
        <link rel="alternate" hreflang="de" :href="url('/legal/widerrufsbelehrung', 'de')">
        <meta name="robots" content="noindex, nofollow">
    </Head>
    <section>
        <div class="container px-4 mx-auto mt-28 lg:mt-36">
            <h1 class="font-semibold text-4xl text-black space-x-3 mb-3">
                Widerrufsrecht
            </h1>
            <p>
                Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses. Um Ihr Widerrufsrecht auszuüben, müssen Sie uns:
            </p>
            <p class="mt-2">
                <br>
                Tobias Holst e.K
                <br>
                Richard-Strauss-Str. 13
                <br>
                81677 München
                <br>
                GERMANY
            </p>
            <p class="mt-2">
                Telefon: +49 89 339 80 65 0
                <br>
                Telefax: +49 89 339 80 65 99
                <br>
                E-Mail: support@lay7.cloud
            </p>
            <p>
                mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
            </p>
            <p>
                Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
            </p>
            <p class="mt-4 text-black text-lg font-bold">
                Folgen des Widerrufs
            </p>
            <p>
                Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
            </p>
        </div>
    </section>
</template>
